import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Display a toast message for a payment
 *
 * @param {Object} param0
 * @param {string} param0.message The message to display
 * @param {number} [param0.studyPersonId] The study person ID
 * @param {number} [param0.studyId] The study ID
 * @param {string} [param0.helpUrl] Help-center article explaining how to fix the error
 */
export function PaymentToastMessage({ message, studyPersonId, studyId, helpUrl }) {
    return (
        <>
            {message}
            {studyPersonId && (
                <>
                    <br />
                    <Link target="_blank" to={`/studies/${studyId}/participants/${studyPersonId}`}>
                        View Participant
                    </Link>
                </>
            )}
            {helpUrl && (
                <>
                    <br />
                    <a href={helpUrl} target="_blank" rel="noopener noreferrer">
                        Learn more
                    </a>
                </>
            )}
        </>
    );
}

export default PaymentToastMessage;
